import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

const defaults = { size: 20, color: 'currentColor' } as const;

const svgProps = (p: IconProps) => ({
  width: p.size ?? defaults.size,
  height: p.size ?? defaults.size,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  style: p.style,
});

const strokeProps = (p: IconProps) => ({
  stroke: p.color ?? defaults.color,
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
});

export const Arrow: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M5 12h14M12 5l7 7-7 7" {...strokeProps(p)} />
  </svg>
);

export const Check: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M20 6L9 17l-5-5" {...strokeProps(p)} />
  </svg>
);

export const Plus: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M12 5v14M5 12h14" {...strokeProps(p)} />
  </svg>
);

export const Email: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <rect x="2" y="4" width="20" height="16" rx="2" {...strokeProps(p)} />
    <path d="M22 7l-10 6L2 7" {...strokeProps(p)} />
  </svg>
);

export const Upload: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" {...strokeProps(p)} />
    <path d="M17 8l-5-5-5 5M12 3v12" {...strokeProps(p)} />
  </svg>
);

export const Camera: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" {...strokeProps(p)} />
    <circle cx="12" cy="13" r="4" {...strokeProps(p)} />
  </svg>
);

export const SMS: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" {...strokeProps(p)} />
  </svg>
);

export const Scan: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M2 7V2h5M17 2h5v5M22 17v5h-5M7 22H2v-5" {...strokeProps(p)} />
    <line x1="5" y1="12" x2="19" y2="12" {...strokeProps(p)} />
  </svg>
);

export const Chevron: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M9 18l6-6-6-6" {...strokeProps(p)} />
  </svg>
);

export const Q: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <circle cx="12" cy="11" r="8" {...strokeProps(p)} />
    <path d="M15 15l5 5" {...strokeProps(p)} />
  </svg>
);

export const X: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M18 6L6 18M6 6l12 12" {...strokeProps(p)} />
  </svg>
);

export const Sparkle: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z" {...strokeProps(p)} />
  </svg>
);

export const Loop: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M17 1l4 4-4 4" {...strokeProps(p)} />
    <path d="M3 11V9a4 4 0 014-4h14" {...strokeProps(p)} />
    <path d="M7 23l-4-4 4-4" {...strokeProps(p)} />
    <path d="M21 13v2a4 4 0 01-4 4H3" {...strokeProps(p)} />
  </svg>
);

export const Attach: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" {...strokeProps(p)} />
  </svg>
);

export const XeroX: React.FC<IconProps> = ({ size = 24 }) => (
  <img
    src="/icons/xero-logo.svg?v=2"
    alt="Xero"
    width={size}
    height={size}
    style={{ display: 'block', flexShrink: 0 }}
  />
);

export const Doc: React.FC<IconProps> = (p) => (
  <svg {...svgProps(p)}>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" {...strokeProps(p)} />
    <polyline points="14 2 14 8 20 8" {...strokeProps(p)} />
    <line x1="16" y1="13" x2="8" y2="13" {...strokeProps(p)} />
    <line x1="16" y1="17" x2="8" y2="17" {...strokeProps(p)} />
    <line x1="10" y1="9" x2="8" y2="9" {...strokeProps(p)} />
  </svg>
);
